/**
 * Maintained By 许晓飞
 */
<template>
  <div style="height: calc(100% - 96px);">
    <div class="container">
      <page-header :title="title" v-if="!isDialog" :customFun="back"></page-header>
      <Group :hideHeader="true" :fold="false" class="content-wrap" :style="{padding: isDialog ? '30px 0px 0px' : '30px 25px 100px'}">
        <div>
          <step :active="active" :stepArr="stepArr"></step>
          <import-content class="import-content" :importSel="importSel" :active="active">
            <!--如果需要选择类型  则第一步-->
            <template slot="selUpload">
              <slot name="importSel"></slot>
            </template>
            <!--如果需要选择类型 此为第二步  反之第一步 以此类推-->
            <template slot="upload">
              <div v-if="(hasUploadTips || $slots['upload-tip']) && isShowUploadTips" class="upload-tip">
                <tip-box>
                  <slot name="upload-tip"></slot>
                  <template slot="close-icon">
                    <i class="close-icon" @click="isShowUploadTips = false"></i>
                  </template>
                </tip-box>
              </div>
              <fe-upload
                ref="upload"
                :action="`${importApis.upload.url}${uploadParams(importApis.upload.parameter)}`"
                @uploadSuccess="uploadSuccess"
                @changeFiles="changeFiles"
                :downloadValidate="downloadValidate"
                :downloadTemplate="`${importApis.downloadTemplate.url}${uploadParams(importApis.downloadTemplate.parameter)}`">
              </fe-upload>
            </template>
            <!--第二步-->
            <template slot="view">
              <div class="tip">
                <tip-box>
                  <p>
                    <!-- <p>提示：共{{failCount + successCount}}条数据，问题数据<span class="highlight">{{failCount}}</span>条，你可以返回修改后重新上传，或者先导入正确数据。</p> -->
                    <span v-html="variableReplace(pageText.dataExplain, {m: failCount + successCount, n: `<span class='hightlight'>${failCount}</span>`})"></span>
                    <el-button v-if="failCount" @click="downloadAll" size="mini" type="primary" plain>{{pageText.downFileBtn}}</el-button>
                  </p>
                </tip-box>
              </div>
              <slot name="table" :tableData="tableData"></slot>
              <div class="see-more" v-show="tableData.length < totalCount" @click="lookMore">
                <!-- 点击加载更多数据> -->
                {{pageText.loadMore}}
              </div>
            </template>
            <!--第三步-->
            <template slot="complete">
              <div class="import-result-tips">
                <div class="part-success-tip" v-if="!failCount">
                  <i class="el-icon-circle-check font-color-success"></i>
                  <span v-if="isDialog" v-html="variableReplace(pageText.importLaterTip, {sec: '<span class=highlight>3</span>'})"></span>
                  <span v-else class="success-text-tip text-tip">操作成功！</span>
                </div>
                <div class="part-fail-tip" v-else>
                  <i class="icon-warning"></i>
                  <span class="fail-text-tip text-tip" v-html="variableReplace(pageText.importNumTip, {successCount: successCount, failCount: '<span class=highlight>' + failCount + '</span>'})"></span>
                </div>
              </div>
            </template>
            <!--按钮区-->
            <template slot="button">
              <div v-if="isDialog" class="buttons">
                <scroll-follow ref="scrollFollow" :disabled="isDialog" :width="'auto'">
                  <div class="buttons-wrap">
                    <el-button v-if="leftButtonText" type="default" size="medium" @click="handleLeftButton" :plain="active === 3">{{leftButtonText}}</el-button>
                    <el-button v-if="rightButtonText" :disabled="this.judgeStep(2) && !successCount"  type="primary" size="medium" @click="handleRightButton">{{rightButtonText}}</el-button>
                  </div>
                </scroll-follow>
              </div>
              <div v-else></div>
            </template>
          </import-content>
        </div>
      </Group>
      <!-- 吸底按钮 -->
      <BottomFixed class="import-button-box" v-if="!isDialog">
          <Buttons v-if="leftButtonText" type="default" size="medium" @click="handleLeftButton" :plain="active === 3">{{leftButtonText}}</Buttons>
          <Buttons v-if="rightButtonText" :disabled="this.judgeStep(2) && !successCount" type="primary" size="medium" @click="handleRightButton">{{rightButtonText}}</Buttons>
      </BottomFixed>
    </div>
  </div>
</template>
<script>
  import getResponse, {isResponseOk} from './../../../utils/response'
  import importApis from './api.js'
  import download from './../../../utils/download'
  import PageHeader from './../../basis/header/index.vue'
  import ImportContent from './components/import-content.vue'
  import FeUpload from './../../business/upload/upload.vue'
  import TipBox from './../../basis/tip-box/tip-box'
  import Step from './../../basis/step/step.vue'
  import BottomFixed from './../../business/bottom-fixed/index.vue'
  import i18n from './i18n.js'
  import { Buttons } from './../../../index.js'
  import ScrollFollow from './../../basis/scroll-follow'
  import { componentMessage } from '../utils'
  const pageText = window.fe.getPageText(i18n)
  export default {
    name: 'sy-import',
    components: {
      PageHeader,
      ImportContent,
      FeUpload,
      TipBox,
      Step,
      BottomFixed,
      Buttons,
      ScrollFollow
    },
    props: {
      'title': String,
      'importType': String,
      // 返回文案
      'returnText': {
        type: String,
        default: pageText.backList
      },
      // 返回路径
      'returnPath': {
        type: String,
        default: '/'
      },
      // 是否有上传提示
      'hasUploadTips': {
        type: Boolean,
        default: false
      },
      // 上传为几步 导入前是否可以选择导入操作方式
      'importSel': {
        type: Boolean,
        default: false
      },
      // 是否弹层形式
      isDialog: {
        type: Boolean,
        default: false
      },
      // 是否需要确人导入
      needImportConfirm: {
        type: Boolean,
        default: true
      },
      // 是否在关闭时获取正确数据，只在弹层模式下用
      needGetSuccessData: {
        type: Boolean,
        default: true
      },
      // 下载前的校验
      downloadValidate: {
        type: Object,
        default: () => ({
          url: '',
          method: '',
          param: {}
        })
      },
      dynamicApis: {
        type: Object,
        default: () => ({})
      }
    },
    data: function () {
      return {
        pageText,
        isShowUploadTips: true,
        // 当前在第几步
        active: 1,
        key: '', // 任务的key
        successCount: 0, // 导入成功的条数
        failCount: 0, // 导入失败的条数
        importApis,
        // 列表展示
        tableData: [],
        totalCount: null,
        page: 0,
        closed: false,
        // 展示步骤条的数组
        stepArr: []
      }
    },
    watch: {
      dynamicApis: {
        handler: function (newVal) {
          if (newVal) {
            let dynamicApisKeys = Object.keys(newVal)
            Array.isArray(dynamicApisKeys) && dynamicApisKeys.forEach(item => {
              this.importApis[item] = newVal[item]
            })
          }
        },
        deep: true,
        immediate: true
      }
    },
    created () {
      let verifyResult = componentMessage(['purchaser', 'supplier', 'mall'], '三步、四部导入组件sy-import')
      if (verifyResult) return
      // 判断步骤
      if (this.importSel) {
        this.stepArr = [pageText.selImportMode, pageText.uploadData, pageText.verifyImport, pageText.finish]
      } else {
        this.stepArr = [pageText.uploadData, pageText.verifyImport, pageText.finish]
      }
    },
    computed: {
      // 右侧按钮文字
      rightButtonText () {
        if (this.judgeStep(3)) {
          return this.failCount ? this.pageText.downloadIncorrectData : this.isDialog ? this.pageText.close : this.returnText
        } else if (this.judgeStep(2)) {
          // 导入正确数据
          return this.pageText.importCorrentData
        } else {
          return this.pageText.nextStep
        }
      },
      // 左侧按钮文字
      leftButtonText () {
        // 最后一步是“返回列表”，其他都是“上一步”
        if (this.judgeStep(3)) {
          return this.failCount ? this.isDialog ? this.pageText.close : this.returnText : ''
        } else if (this.active === 1) {
          return ''
        } else {
          return this.pageText.lastStep
        }
      },
      //  动态参数
      uploadParams () {
        return function (data) {
          let param = `?importType=${this.importType}`
          let paramsKeys = Object.keys(data)
          Array.isArray(paramsKeys) && paramsKeys.forEach(item => {
            param = `${param}&${item}=${data[item]}`
          })
          return param
        }
      }
    },
    updated () {
      this.$refs['scrollFollow'] && this.$refs['scrollFollow'].update && this.$refs['scrollFollow'].update()
    },
    methods: {
      variableReplace: window.fe.variableReplace,
      // 判断当前是第几步，按标准的3步导入算
      judgeStep (step) {
        return (this.importSel && this.active === (step + 1)) || (!this.importSel && this.active === step)
      },
      // 右侧按钮操作
      handleRightButton () {
        const self = this
        if (this.importSel && self.active === 1) {
          self.active++
          // 抛出校验
          this.$emit('checkMessage')
        } else if (this.judgeStep(1)) {
          // 上传完成后，下一步
          if (self.key) {
            self.active++
            self.loadDataList(true)
          } else {
            self.$message.warning(this.pageText.importExcel)
          }
        } else if (this.judgeStep(2)) {
          // 导入有效数据
          this.loadValid()
        } else if (this.judgeStep(3)) {
          if (self.failCount) {
            // 下载问题数据
            let api = this.importApis.error
            download(api.type, api.url, {
              key: self.key,
              importType: this.importType
            })
          } else {
            // 返回列表或关闭
            this.isDialog ? this.close() : this.back()
          }
        }
      },
      // 左侧按钮操作
      handleLeftButton () {
        if (this.judgeStep(2)) {
          // 当前在预览界面,点击上一步, 需重置数据
          this.reset()
          this.active -= 1
        } else if (this.judgeStep(3)) {
          // 返回列表或关闭
          this.isDialog ? this.close() : this.back()
        }
      },
      // 返回列表页面
      back () {
        this.$routerPush(this.returnPath)
      },
      // 上传表格文件成功
      async uploadSuccess (res) {
        const self = this
        // 有后台返回content为空的情况
        if (!res.content) {
          this.reset()
        }
        if (isResponseOk(res)) {
          self.key = res.content.key
          self.successCount = res.content.success
          self.failCount = res.content.fail
          self.$message.success(this.pageText.uploadSuccess)
        } else {
          self.key = ''
        }
      },
      // 文件选取发生变化
      async changeFiles (files) {
        if (!files) {
          this.reset()
        }
      },
      // 获取列表数据
      async loadDataList (isFirst) {
        const api = this.importApis.list
        const param = {
          key: this.key,
          page: isFirst ? 1 : ++this.page,
          pageSize: isFirst ? 10 : 500
        }
        const res = await getResponse(this.$http(api.type, api.url, param), {
          loadingOptions: true
        })
        if (res.isOk) {
          if (isFirst || this.page === 1) {
            this.tableData = res.content
          } else {
            this.tableData = this.tableData.concat(res.content)
          }
          this.totalCount = res.count
        }
      },
      // 列表加载更多
      lookMore () {
        // this.displayList = this.tableData
        this.loadDataList(false)
      },
      // 导入有效数据
      async loadValid () {
        if (this.needImportConfirm) {
          const api = this.importApis.confirm
          const param = {
            key: this.key,
            importType: this.importType
          }
          const data = await getResponse(this.$http(api.type, api.url, param), {
            loadingOptions: true
          })
          if (data.isOk && data.content) {
            this.successCount = data.content.success
            this.failCount = data.content.fail
            this.active++
          }
        } else {
          this.active++
        }
        // 弹窗&&没有错误数据时： 3s后自动关闭
        if (this.isDialog && !this.failCount) {
          setTimeout(() => {
            this.close()
          }, 3000)
        }
      },
      // 弹层形式时，关闭
      async close () {
        if (this.closed) return
        if (!this.needGetSuccessData) {
          this.$emit('confirm', {
            key: this.key
          })
          this.closed = true
          return
        }
        const api = this.importApis.getSuccessData
        const res = await getResponse(this.$http(api.type, api.url, {
          'importType': this.importType,
          'key': this.key,
          'successCount': this.successCount // 导入模板时返回的成功数量
        }), {
          loadingOptions: false
        })
        if (res.isOk) {
          this.$emit('confirm', {
            key: this.key,
            content: res.content
          })
          this.closed = true
        }
      },
      // 重置
      reset () {
        this.key = ''
        this.successCount = 0
        this.failCount = 0
        this.tableData = []
        this.totalCount = null
        this.page = 0
        this.$refs['upload'] && this.$refs['upload'].reset()
      },
      // 下载所有数据（有错误标识）
      async downloadAll () {
        const api = this.importApis.downloadAllData
        download(api.type, api.url, {
          key: this.key,
          importType: this.importType
        })
      }
    }
  }
</script>
<style lang="scss" scoped>
  .content-wrap{
    // padding: 30px 25px 100px;
    position: relative;
  }
  .import-content{
    padding-top: 30px;
  }
  .upload-tip{
    margin-top: -10px;
    margin-bottom: -40px;
    .close-icon{
      display: inline-block;
      background: url($img-url + "156221174329914369.svg") no-repeat;
      width: 100%;
      height: 100%;
    }
  }
  .tip {
    margin: 10px auto;
  }
  .see-more{
    margin-top: 10px;
    font-size: 14px;
    color: #3072F3;
    cursor: pointer;
  }
  .error{
    color: #F23D3D;
  }
  .buttons{
    margin-top: 75px;
    ::v-deep .sy-scroll-follow {
      box-shadow: none;
    }
  }

  .guide{
    width: 230px;
    a{
      display: inline-block;
      width: 120px;
      height: 120px;
      margin-bottom: 8px;
    }
  }
  .buttons-wrap{
    text-align: center;
    line-height: 65px;
  }
  /*导入完成时的样式*/
  .import-result-tips{
    padding-top: 110px;
    text-align: center;
    font-size: 24px;
    .part-success-tip {
      i{
        font-size: 58px;
        vertical-align: middle;
      }
    }
    .part-fail-tip{
      padding-left: 5px;
      .icon-warning{
        display: inline-block;
        height: 53px;
        width: 53px;
        background: url($img-url + "1545644088269warning.png") no-repeat;
        -webkit-background-size: 53px;
        background-size: 53px;
        vertical-align: middle;
      }
    }
    .text-tip {
      margin-left: 15px;
      color: #2C2C2C;
      font-weight: 500;
    }
  }
</style>

